
import styled from "@emotion/styled"
import Particles from "react-particles-js"

import { breakpoints, dimensions, theme } from "../../../utils/styles"

// Opaque full-bleed backdrop behind the rounded card — see TwoColGrid's
// Backdrop for why this is needed (site footer is a fixed, negative
// z-index element revealed only near the true page bottom; flow-root
// stops the card's vertical margin from collapsing through this wrapper
// and re-exposing the bare page background where the footer would bleed
// through).
export const Backdrop = styled.div`
  position: relative;
  z-index: 1;
  background: ${({ theme }) => theme.black};
  display: flow-root;
`

export const Section = styled.section`
  background: ${({ theme }) => theme.white};
  overflow: hidden;
  position: relative;
  isolation: isolate;
  border-radius: 32px;
  margin: 48px 32px;

  @media (max-width: ${breakpoints.l}px) {
    margin: 24px 16px;
    border-radius: 20px;
  }
`

export const ParticleLayer = styled(Particles)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

export const Container = styled.div`
  max-width: ${dimensions.contentWidth};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0;

  @media (max-width: ${breakpoints.l}px) {
    padding: 48px 24px;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
  margin-bottom: 8px;
`

export const Eyebrow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme.primary};
  white-space: nowrap;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${theme.primary};
  }
`

export const CategoryTabs = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
  z-index: 10;
`

export const CategoryButton = styled.button`
  font-family: Nunito, sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.03em;
  padding: 10px 24px;
  border-radius: 999px;
  border: 1.5px solid ${theme.primary};
  background: ${({ active }) => (active ? theme.primary : "transparent")};
  color: ${theme.black};
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease;

  &:hover {
    background: ${theme.primary};
    transform: translateY(-2px);
  }
`

export const MembersRow = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 56px 0 32px;
  position: relative;
  z-index: 2;

  @media (max-width: ${breakpoints.l}px) {
    padding: 32px 0;
  }
`

export const MemberCard = styled.a`
  display: block;
  width: 220px;
  border-radius: 14px;
  overflow: hidden;
  border-top: 3px solid ${theme.primary};
  background: ${theme.surface};
  text-decoration: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.35s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.22);
  }

  @media (max-width: ${breakpoints.m}px) {
    width: 160px;
  }
`

export const MemberPhoto = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-color: ${theme.primary};
  background-size: cover;
  background-position: center;
`

export const MemberSlip = styled.div`
  padding: 14px 16px 16px;
`

export const MemberName = styled.h4`
  margin: 0 0 2px 0;
  font-weight: 700;
  font-size: 16px;
  color: ${theme.white};
  font-family: Nunito, sans-serif;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 14px;
  }
`

export const MemberPosition = styled.p`
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);

  @media (max-width: ${breakpoints.m}px) {
    font-size: 11px;
  }
`
